module.exports = __webpack_public_path__ + "static/media/2 Wheeler.e8a21514.svg";